import { css } from '@emotion/react';
import { useState, useEffect } from 'react';
import { gray6 } from 'styles/global_defaults/colors';
import { halfSpacing } from 'styles/global_defaults/scaffolding';

const NvUploadProgressBar = ({ isUploading, inputProgress }) => {
  const [progress, setProgress] = useState(inputProgress);

  useEffect(() => {
    let interval;

    if (inputProgress === undefined || inputProgress === false) {
      if (isUploading) {
        setProgress(0); // Reset progress on new upload
        interval = setInterval(() => {
          setProgress((prev) => (prev < 95 ? prev + 5 : prev)); // Gradually increase
        }, 300);
      } else {
        setProgress(100); // Set to 100% when done
      }
    } else {
      setProgress(inputProgress); // Set to input progress if provided
    }

    return () => clearInterval(interval); // Cleanup on unmount or when complete
  }, [isUploading, inputProgress]);

  const styles = css`
    .progess-container {
      borderRadius: 10px;
      background: ${gray6};
    }
    .progress-bar1 {
      background: linear-gradient(48.41deg, #60F3AB 0%, #00CCBC 45%, #009AC0 100%);
      transition: width 0.2s ease-in-out;
      border-radius: ${halfSpacing}px;
      height: ${halfSpacing}px;
    }
  `;

  return (
    <div css={styles}>
      <div className='progess-container'>
        <div
          className='progress-bar1'
          style={{
            width: `${progress}%`,
          }}
        />
      </div>
    </div>

  );
};

export default NvUploadProgressBar;
